import { useParams, useNavigate } from "react-router-dom";
import useServices from "../hooks/useServices";
import RequestCallForm from "../components/RequestCallForm";
import { CURRENCY_NOTE, registerByEmailHref } from "../data/practice";

function formatPrice(amount) {
  const n = Number(amount);
  if (!Number.isFinite(n)) return "";
  if (n === 0) return "Free";
  return `$${Number.isInteger(n) ? n : n.toFixed(2)}`;
}

export default function ServiceDetail() {
  const { slug } = useParams();
  const navigate = useNavigate();
  // Static copy merged with the backend's price/duration (backend wins).
  const { services } = useServices();
  const service = services.find(s => s.slug === slug);

  if (!service) {
    return (
      <section className="section white">
        <div className="container">
          <h1>Service not found</h1>
          <button type="button" className="btn-cta" onClick={() => navigate('/#services')}>
            Back to Services
          </button>
        </div>
      </section>
    );
  }

  const goCheckout = () => {
    navigate(`/checkout?service=${encodeURIComponent(service.slug)}`);
  };

  const registerHref = registerByEmailHref(service.title);

  return (
    <section className="section white">
      <div className="container">
        <h1>{service.title}</h1>
        <p className="muted">{service.duration} • {formatPrice(service.price)}</p>
        {Number(service.price) > 0 ? <p className="muted currency-note">{CURRENCY_NOTE}</p> : null}

        <div className="about" style={{marginTop:"1rem"}}>
          <div className="copy" style={{width: "100%"}}>
            <div className="policy-content">{service.long}</div>

            <div style={{display:"flex", gap:".5rem", marginTop:"1rem", flexWrap:"wrap"}}>
              {service.bookableOnline === false ? (
                <a className="btn-cta" href={registerHref}>Email to Register</a>
              ) : (
                <button type="button" className="btn-cta" onClick={goCheckout}>Book Now</button>
              )}
              <button type="button" className="btn-cta" onClick={() => navigate('/#services')}>
                Back to Services
              </button>
            </div>

            <p className="muted" style={{marginTop:"1rem"}}>
              Need help choosing a service? Request a call, and I’ll call you at a time that works for you.
            </p>
            <RequestCallForm collapsible />
          </div>
        </div>
      </div>
    </section>
  );
}
